module.exports = __webpack_public_path__ + "static/img/wy.902178e7.png";